// Collection of 49 different avatars for users to choose from
// 50th option is a custom upload button in the UI
export const AVATARS = [
  '😊', // Happy
  '😎', // Cool
  '🤓', // Nerd
  '🥳', // Party
  '😇', // Angel
  '🤠', // Cowboy
  '🥷', // Ninja
  '👨‍💼', // Business
  '👩‍💼', // Business Woman
  '👨‍🎓', // Graduate
  '👩‍🎓', // Graduate Woman
  '👨‍💻', // Developer
  '👩‍💻', // Developer Woman
  '🧑‍🚀', // Astronaut
  '👨‍🚀', // Astronaut Man
  '👩‍🚀', // Astronaut Woman
  '🦸', // Superhero
  '🦹', // Supervillain
  '🧙', // Wizard
  '🧝', // Elf
  '🧛', // Vampire
  '🧚', // Fairy
  '🐶', // Dog
  '🐱', // Cat
  '🐭', // Mouse
  '🐹', // Hamster
  '🐰', // Rabbit
  '🦊', // Fox
  '🐻', // Bear
  '🐼', // Panda
  '🐨', // Koala
  '🐯', // Tiger
  '🦁', // Lion
  '🐮', // Cow
  '🐷', // Pig
  '🐸', // Frog
  '🐵', // Monkey
  '🦄', // Unicorn
  '🦋', // Butterfly
  '🐝', // Bee
  '🦅', // Eagle
  '🦉', // Owl
  '🦆', // Duck
  '🐧', // Penguin
  '🦖', // T-Rex
  '🐲', // Dragon
  '🌟', // Star
  '⭐', // Star 2
  '💎', // Diamond
];

// Get default avatar
export const getDefaultAvatar = () => AVATARS[0]; // 😊

// Get random avatar
export const getRandomAvatar = () => {
  const randomIndex = Math.floor(Math.random() * AVATARS.length);
  return AVATARS[randomIndex];
};

// Check if avatar is valid
export const isValidAvatar = (avatar) => {
  return AVATARS.includes(avatar);
};

// Get avatar by index
export const getAvatarByIndex = (index) => {
  if (index >= 0 && index < AVATARS.length) {
    return AVATARS[index];
  }
  return getDefaultAvatar();
};
